/// <reference path="./qrcode.d.ts" />
import QRCode from 'qrcode';

/**
 * 生成二维码 dataURL（账户身份码 / 工牌打印）。
 * 用 M 级纠错：账户码内容约 80 字符，M 级足够抗污损，同时模块数不至于太密（手机/PDA 好扫）。
 */
export async function qrDataUrl(text: string, size = 260): Promise<string> {
  return QRCode.toDataURL(text, {
    width: size,
    margin: 1,
    errorCorrectionLevel: 'M',
    color: { dark: '#000000', light: '#ffffff' }
  });
}

/** 下载 dataURL 为文件（浏览器端）。 */
export function downloadDataUrl(dataUrl: string, fileName: string): void {
  const link = document.createElement('a');
  link.href = dataUrl;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

/** 文件名里的非法字符统一替换，避免下载失败。 */
export function safeFileName(name: string): string {
  return name.replace(/[\\/:*?"<>|\s]+/g, '_').slice(0, 60) || 'account';
}
